import { SMART_CONTRACT_PLUGINS } from "@/components/SmartContractDesigner/plugins";
import { SMART_CONTRACT_TYPES, SMART_CONTRACT_PLUGIN_IDS } from "@/components/SmartContractDesigner/smartContractPluginIDs";
import { DIAGRAM_PLUGINS } from "../Diagram/const/plugins";

export const SMART_CONTRACT_PLUGIN_CATEGORIES = [
    {
        title: "Events",
        plugins: [
            {
                id: SMART_CONTRACT_TYPES.GENERAL_START_PLUGIN,
                title: "Start",
                plugin: DIAGRAM_PLUGINS.GeneralStartPlugin,
                type: "rectangle"
            },
            {
                id: SMART_CONTRACT_TYPES.GENERAL_END_PLUGIN,
                title: "End",
                plugin: DIAGRAM_PLUGINS.GeneralEndPlugin,
                type: "circle"
            }
        ]
    },

    {
        title: "Variables",
        displayPreview: true,
        plugins: [
            {
                id: SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_ASSIGN,
                title: "Assign",
                plugin: SMART_CONTRACT_PLUGINS.AssignPlugin,
                type: "rectangle",
                hasOwnState: false,
                displayPreview: true
            },
            {
                id: SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_DECLARE,
                title: "Declare",
                plugin: SMART_CONTRACT_PLUGINS.DeclarePlugin,
                type: "rectangle",
                hasOwnState: false,
                displayPreview: true
            }
        ]
    },
    {
        title: "Control",
        displayPreview: true,
        plugins: [
            {
                id: SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_EXPRESSION,
                title: "Custom",
                plugin: SMART_CONTRACT_PLUGINS.ExpressionPlugin,
                type: "rectangle",
                hasOwnState: false,
                displayPreview: true
            },
            {
                id: SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_IF,
                title: "If",
                plugin: SMART_CONTRACT_PLUGINS.IfPlugin,
                type: "rectangle",
                hasOwnState: false,
                displayPreview: true
            },
            {
                id: SMART_CONTRACT_TYPES.SMART_CONTRACT_DELIMITATOR,
                title: "Delimitator",
                plugin: SMART_CONTRACT_PLUGINS.GenericConnectingCirclePlugin,
                type: "rectangle",
                hasOwnState: false,
                displayPreview: true
            }
        ]
    },
    {
        title: "Looping",
        displayPreview: true,
        plugins: [
            {
                id: SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_DO_WHILE,
                title: "Do While",
                plugin: SMART_CONTRACT_PLUGINS.DoWhileLoopPlugin,
                type: "rectangle",
                hasOwnState: false,
                displayPreview: true
            },
            {
                id: SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_WHILE,
                title: "While",
                plugin: SMART_CONTRACT_PLUGINS.WhileLoopPlugin,
                type: "rectangle",
                hasOwnState: false,
                displayPreview: true
            },
            {
                id: SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_FOR,
                title: "For",
                plugin: SMART_CONTRACT_PLUGINS.ForLoopPlugin,
                type: "rectangle",
                hasOwnState: false,
                displayPreview: true
            }

        ]
    },
    {
        title: "Actions",
        displayPreview: true,
        plugins: [
            {
                id: SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_FUNCTION_CALL,
                title: "Call Function",
                plugin: SMART_CONTRACT_PLUGINS.FunctionCallPlugin,
                type: "rectangle",
                hasOwnState: false,
                displayPreview: true
            },
            {
                id: SMART_CONTRACT_PLUGIN_IDS.SMART_CONTRACT_EMIT_EVENT,
                title: "Emit Event",
                plugin: SMART_CONTRACT_PLUGINS.EmitEventPlugin,
                type: "rectangle",
                hasOwnState: false,
                displayPreview: true,
                disabled: false
            }
        ]
    }
];
